module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0018.f71a961c.jpg";